import React, { useState, useEffect, useRef } from "react";
import "./styled.css";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";
// utils
import { functionLog } from "../../services/qrCode";
import { createEarnedPoints } from "../../services/ranking";
// html qrcode
import { Html5Qrcode } from "html5-qrcode";
// moment
import moment from "moment";
// componentes e img
import Logo from "../../assets/image/icon.png";
import ListQrcode from "./listQrcode";
import ModalInfo from "./ModalInfo";

export default function ReadQrcode(props) {
  const {
    colorBtn,
    imgLogo,
    listCodesRead,
    user,
    getListRead,
    listAllCodes,
    showQrcodeList,
    limitByPeriod,
    dateStart,
    dateEnd,
    buttonName,
    modalContent,
  } = props;

  const [scan, setScan] = useState(false);
  const [qrcodeRead, setQrcodeRead] = useState(false);
  const [error, setError] = useState("");
  const [warning, setWarning] = useState('')
  const [listQrcode, setListQrcode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [fullQrcodes, setFullQrcodes] = useState(false);
  const [cameraLoading, setCameraLoading] = useState(false);
  const [modalInfo, setModalInfo] = useState(false);

  const scannerRef = useRef(null);
  const hasScannedRef = useRef(false);

  async function readScan(e) {
    hasScannedRef.current = true;
    setLoading(true);

    try {
      const search = listAllCodes.find((code) => code.id === e);

      if (!search) {
        setError("O QR Code lido não é válido");
        return;
      }

      if (search.read === "sim") {
        setWarning("Esse QRCode já foi usado!");
        return;
      }

      const dataRanking = {
        code: search.type,
        positive: true,
        log: "add points qrcode",
      };

      const res = await createEarnedPoints(
        dataRanking,
        user.idEvent,
        user.idPart,
      );

      if (res.message === "ADDED_TO_QUEUE") {
        const dataCheck = {
          eventId: user.idEvent,
          loginId: user.idPart,
          functionId: search.id,
        };

        const resCheck = await functionLog(dataCheck);

        if (resCheck.data.message === "CREATED") {
          setQrcodeRead(true);
        } else if (resCheck.data.message === "FUNCTION_YET_RELEASED") {
          setWarning("Esse QRCode já foi usado!");
        } else {
          setError("Erro ao ler o QR Code, tente novamente em breve");
        }
      }
    } catch (err) {
      setError("Erro ao pontuar, tente novamente em breve");
    } finally {
      setLoading(false);
    }
  }

  async function changeScan() {
    const div = document.getElementById("card-id");
    div.style.transform = "rotateY(90deg)";

    setTimeout(async () => {
      if (scan) {
        if (scannerRef.current) {
          await scannerRef.current.stop();
          await scannerRef.current.clear();
          scannerRef.current = null;
          hasScannedRef.current = false;
        }
        setScan(false);
      } else {
        const scanner = new Html5Qrcode("html5qr-code");
        scannerRef.current = scanner;

        try {
          await scanner.start(
            { facingMode: "environment" },
            {
              fps: 10,
              qrbox: { width: 200, height: 200 },
              aspectRatio: 1.0,
            },
            (decodedText) => {
              if (!hasScannedRef.current && !loading) {
                hasScannedRef.current = true;
                readScan(decodedText);
              }
            },
          );

          setScan(true);
          setCameraLoading(true);
        } catch (err) {
          console.error("Erro ao iniciar scanner:", err);
          setError("Erro ao abrir a câmera.");
        }
      }

      div.style.transform = "rotateY(0)";
    }, 400);
    setCameraLoading(false);
  }

  useEffect(() => {
    if (listCodesRead && !listCodesRead.find((e) => e.read === "nao")) {
      setFullQrcodes(true);
    } else {
      setFullQrcodes(false);
    }

    return () => {
      if (scannerRef.current) {
        scannerRef.current.stop().then(() => scannerRef.current.clear());
      }
    };
  }, [listCodesRead]);

  const now = moment();
  const beforeStart = limitByPeriod && now.isBefore(moment(dateStart));
  const afterEnd = limitByPeriod && now.isAfter(moment(dateEnd));

  return (
    <>
      {qrcodeRead && (
        <SweetAlert
          success
          title="Pontos atribuídos"
          onConfirm={() => {
            getListRead();
            setQrcodeRead(false);
            hasScannedRef.current = false; // ← libera a leitura
            setScan(false);
            setCameraLoading(false);
          }}
        >
          Pontos atribuídos ao participante!
        </SweetAlert>
      )}

      {error && (
        <SweetAlert
          error
          title="Alerta"
          onConfirm={() => {
            setError("");
            hasScannedRef.current = false;
          }}
        >
          {error}
        </SweetAlert>
      )}

      {warning && (
        <SweetAlert
          warning
          title="Alerta"
          onConfirm={() => {
            setWarning("");
            hasScannedRef.current = false;
          }}
        >
          {warning}
        </SweetAlert>
      )}

      {listQrcode && (
        <ListQrcode
          isOpen={listQrcode}
          toggle={() => setListQrcode(false)}
          listCodesRead={listCodesRead}
        />
      )}

      {modalInfo && (
        <ModalInfo
          isOpen={modalInfo}
          toggle={() => setModalInfo(false)}
          modalContent={modalContent}
          buttonName={buttonName}
        />
      )}

      <div className="card-general-qrcode" id="card-id">
        <div className="qrcode-wrapper">
          {cameraLoading && (
            <div
              className="loading-pulse"
              style={{
                backgroundColor: "#2e2e2e",
                position: "absolute",
                top: 0,
                left: 0,
                zIndex: 0,
                borderRadius: 10,
              }}
            />
          )}
          <div
            id="html5qr-code"
            style={{
              position: "relative",
              overflow: "hidden", // ← ajuda no Safari
            }}
          />
          {!scan && (
            <img
              src={imgLogo || Logo}
              alt="Logo"
              style={{
                borderRadius: "50%",
                position: "absolute",
                top: 0,
                left: 0,
                zIndex: 1,
              }}
            />
          )}
        </div>
      </div>

      {fullQrcodes ? (
        <h3 className="qrcode-msg" style={{ textAlign: "center" }}>
          Parabéns, você já leu todos os QRCode's e ganhou todos os pontos!
        </h3>
      ) : (
        <>
          {scan ? (
            <a className="action-reader close-reader" onClick={changeScan}>
              Fechar Scan
            </a>
          ) : (
            <>
              {beforeStart || afterEnd ? (
                <a className="a-message-info">
                  {beforeStart && (
                    <>
                      O leitor ficará disponível no dia{" "}
                      {moment(dateStart).format("DD/MM/YYYY")} às{" "}
                      {moment(dateStart).format("H:mm")}
                    </>
                  )}

                  {afterEnd && <>O período de leitura dos QR Codes terminou</>}
                </a>
              ) : (
                <>
                  <a
                    className="action-reader open-reader"
                    style={{ backgroundColor: colorBtn }}
                    onClick={changeScan}
                  >
                    <i className="bx bx-camera icon-button" /> Ler QRCode
                  </a>
                </>
              )}
            </>
          )}
        </>
      )}

      {showQrcodeList && (
        <a
          className="action-reader open-reader"
          style={{ backgroundColor: colorBtn }}
          onClick={() => setListQrcode(true)}
        >
          <i className="bx bx-list-ul icon-button" /> Lista de QRCodes
        </a>
      )}

      {buttonName && (
        <a
          className="action-reader open-reader"
          style={{ backgroundColor: colorBtn }}
          onClick={() => setModalInfo(true)}
        >
          <i className="bx bx-info-circle icon-button" /> {buttonName}
        </a>
      )}
    </>
  );
}
